
import { defineComponent } from 'vue'
import IconSvg from '@/components/IconSvg.vue'

export default defineComponent({
	name: 'EventDateIcon',

	components: { IconSvg },

	props: {
		shortMonth: {
			type: String,
			default: ''
		},

		day: {
			type: String,
			default: ''
		}
	}
})
